@if (!showOpeningHours() || portalDataService.isLoadingBranchDetails()) {
  <div class="fade-in-left">
    <div class="portal-header">
      <h2>{{ 'PORTAL.WELCOME.HEADER.TITLE' | translate }}</h2>
      <p>{{ 'PORTAL.WELCOME.HEADER.SUBTITLE' | translate }}</p>
      <h1>{{ branch.nickName }}</h1>
    </div>
    <div class="button-group">
      @if (!isJeronimo) {
        <button
          mat-flat-button
          color="primary"
          type="button"
          [disabled]="branch.open === false"
          (click)="joinWaitingList.emit()">
          {{
            branch.open
              ? ('PORTAL.WELCOME.BUTTONS.JOIN_QUEUE' | translate)
              : ('PORTAL.WELCOME.BUTTONS.QUEUE_UNAVAILABLE' | translate)
          }}
        </button>
      }
      <button mat-stroked-button type="button" (click)="onViewMenu()">
        {{ 'PORTAL.WELCOME.BUTTONS.VIEW_MENU' | translate }}
      </button>
      @if(branch.code !== 'H011'){
        <a mat-stroked-button href="https://pwa.grupomadero.com.br" target="_blank">
          {{ 'PORTAL.WELCOME.BUTTONS.ORDER_ONLINE' | translate }}
        </a>
      }
      <button
        mat-stroked-button
        type="button"
        (click)="onBindOpeningHours()"
        [disabled]="portalDataService.isLoadingBranchDetails()">
        @if (portalDataService.isLoadingBranchDetails()) {
          <div class="c-btn-spinner">
            <mat-spinner class="c-btn-spinner__spinner" color="primary"></mat-spinner>
            <span>{{ 'PORTAL.WELCOME.BUTTONS.LOADING_HOURS' | translate }}</span>
          </div>
        } @else {
          <span>{{ 'PORTAL.WELCOME.BUTTONS.VIEW_HOURS' | translate }}</span>
        }
      </button>
    </div>
  </div>
} @else if (showOpeningHours() && !portalDataService.isLoadingBranchDetails()) {
  <madero-opening-hours (return)="showOpeningHours.set(false)"> </madero-opening-hours>
}
